/* Liquid-glass header behaviour
   - toggles html.header-is-scrolled as soon as the page moves
   - keeps html.header-over-hero in sync with the actual presence of a hero
   - measures the real header height into --header-h so the hero overlay is exact
   All visual work is done in CSS (header-glass.css); this only flips classes. */
(function () {
  var docEl = document.documentElement;
  var SCROLLED_AT = 8; // px of scroll before the bar starts frosting

  function reconcileHero() {
    var hasHero = !!document.querySelector('.premium-hero');
    docEl.classList.toggle('header-over-hero', hasHero);
  }

  function measureHeader() {
    var header = document.getElementById('shopify-section-header');
    if (!header) return;
    var h = header.offsetHeight;
    if (h) docEl.style.setProperty('--header-h', h + 'px');
  }

  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.pageYOffset || docEl.scrollTop || 0;
      docEl.classList.toggle('header-is-scrolled', y > SCROLLED_AT);
      ticking = false;
    });
  }

  function init() {
    reconcileHero();
    measureHeader();
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measureHeader, { passive: true });
    // Fonts/images can change header height after first paint
    window.addEventListener('load', measureHeader);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
